export default __webpack_public_path__ + "static/media/dpr-commingsoon.1f35352c.svg";